// src/components/placement/PlacementModeSelector.jsx
import React from 'react';
import { Target, Award } from 'lucide-react';

export default function PlacementModeSelector({ onSelectMode, onClose }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-purple-600 to-fuchsia-500 flex flex-col items-center justify-center p-6 text-white relative">
      {/* Cerrar */}
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-4 right-4 px-3 py-1.5 bg-white/10 rounded-full text-xs font-bold hover:bg-white/20 transition-colors"
        >
          Cerrar
        </button>
      )}

      <div className="bg-white/10 rounded-3xl px-5 py-2 text-[10px] font-black uppercase tracking-[0.25em] mb-4 border border-white/20">
        Examen de nivel
      </div>

      <h1 className="text-3xl font-black text-center leading-tight mb-2">
        Descubre tu nivel de inglés
      </h1>
      <p className="text-sm text-white/80 text-center max-w-md mb-8">
        Responde preguntas de grammar, vocabulary y reading. 
        Puedes hacer un test rápido o el desafío completo con diploma.
      </p>

      <div className="w-full max-w-md space-y-4">
        {/* PLACEMENT RÁPIDO */}
        <button
          onClick={() => onSelectMode('placement')}
          className="w-full bg-white text-indigo-700 rounded-3xl px-5 py-4 flex items-center gap-3 shadow-xl hover:scale-[1.02] active:scale-[0.97] transition-all border border-white/60"
        >
          <div className="w-10 h-10 rounded-2xl bg-indigo-100 flex items-center justify-center text-indigo-600">
            <Target size={22} />
          </div>
          <div className="flex-1 text-left">
            <p className="text-[11px] font-black uppercase tracking-[0.16em] text-indigo-400">
              Rápido · 5 minutos
            </p>
            <p className="text-sm font-black text-slate-800">Placement Test</p>
            <p className="text-xs text-slate-500">
              15 preguntas adaptativas para estimar tu nivel CEFR (A1–C2).
            </p>
          </div>
        </button>

        {/* MASTER CHALLENGE */}
        <button
          onClick={() => onSelectMode('master')}
          className="w-full bg-indigo-900/90 text-white rounded-3xl px-5 py-4 flex items-center gap-3 shadow-2xl shadow-indigo-900/60 hover:scale-[1.02] active:scale-[0.97] transition-all border border-indigo-400/70"
        >
          <div className="w-10 h-10 rounded-2xl bg-amber-300 flex items-center justify-center text-amber-900">
            <Award size={22} />
          </div>
          <div className="flex-1 text-left">
            <p className="text-[11px] font-black uppercase tracking-[0.16em] text-amber-300">
              Completo · Diploma
            </p>
            <p className="text-sm font-black text-white">Master Challenge</p>
            <p className="text-xs text-indigo-100">
              40 preguntas detalladas. Obtén tu diploma con nivel y porcentajes por habilidad.
            </p>
          </div>
        </button>
      </div>
    </div>
  );
}
